(function () {
  'use strict';

  var intervalId = null;

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function getNextCutoff(now) {
    var cutoff = new Date(now);
    cutoff.setHours(12, 0, 0, 0);

    var day = now.getDay();
    var beforeCutoff = now < cutoff;

    if (day >= 1 && day <= 5 && beforeCutoff) {
      return {
        date: cutoff,
        label: 'wyślemy dzisiaj',
        title: 'Wysyłka dzisiaj'
      };
    }

    var next = new Date(now);
    next.setHours(12, 0, 0, 0);

    if (day >= 1 && day <= 4) {
      next.setDate(now.getDate() + 1);
      return {
        date: next,
        label: 'wyślemy jutro',
        title: 'Wysyłka jutro'
      };
    }

    if (day === 5) {
      next.setDate(now.getDate() + 3);
      return {
        date: next,
        label: 'wyślemy w poniedziałek',
        title: 'Wysyłka w poniedziałek'
      };
    }

    if (day === 6) {
      next.setDate(now.getDate() + 2);
      return {
        date: next,
        label: 'wyślemy w poniedziałek',
        title: 'Wysyłka w poniedziałek'
      };
    }

    if (day === 0) {
      next.setDate(now.getDate() + 1);
      return {
        date: next,
        label: 'wyślemy w poniedziałek',
        title: 'Wysyłka w poniedziałek'
      };
    }

    return {
      date: cutoff,
      label: 'wyślemy w najbliższy dzień roboczy',
      title: 'Szybka wysyłka'
    };
  }

  function formatRemaining(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    if (days > 0) {
      return days + ' dni ' + pad(hours) + ' godz. ' + pad(minutes) + ' min';
    }

    return pad(hours) + ' godz. ' + pad(minutes) + ' min ' + pad(seconds) + ' sek.';
  }

  function updateSingleCounter(wrapper) {
    var titleElement = wrapper.querySelector('[data-shipping-title]');
    var textElement = wrapper.querySelector('[data-shipping-text]');

    if (!titleElement || !textElement) {
      return;
    }

    var now = new Date();
    var target = getNextCutoff(now);
    var remaining = target.date - now;

    titleElement.textContent = target.title;
    textElement.innerHTML =
      'Złóż zamówienie w ciągu <span class="loanti-shipping-counter__time">' +
      formatRemaining(remaining) +
      '</span> <span class="loanti-shipping-counter__badge">' +
      target.label +
      '</span>';
  }

  function updateAllCounters() {
    document.querySelectorAll('[data-loanti-shipping-counter]').forEach(updateSingleCounter);
  }

  function ensureInterval() {
    if (intervalId !== null) {
      return;
    }

    intervalId = window.setInterval(updateAllCounters, 1000);
  }

  window.LoantiShippingCounterInit = function (root) {
    var scope = root || document;
    var counters = scope.querySelectorAll('[data-loanti-shipping-counter]');

    if (!counters.length) {
      return;
    }

    counters.forEach(updateSingleCounter);
    ensureInterval();
  };

  function onReady() {
    window.LoantiShippingCounterInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('quickview:loaded', function () {
    window.LoantiShippingCounterInit();
  });

  document.addEventListener('quickview:open', function () {
    window.LoantiShippingCounterInit();
  });
})();
